<template>
  <div id="app">
    <el-container>
      <el-header class="div-header">
        <Header />
        <el-divider class="header-divider"></el-divider>
      </el-header>
      <div class="main-div">
        <el-container class="main-div parentDiv">
          <splitpanes class="default-theme defaultStyle custom-splite">
            <pane size="100" class="SideBarLeft">
              <!--SID1010 Body Part -->
              <template>
                <el-container>
                  <div class="SID1010__UserGroupList">
                    <!-- Top section -->
                    <section>
                      <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '0002' }">トップ(記事一覧)</el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: '' }">ユーザーグループ一覧</el-breadcrumb-item>
                      </el-breadcrumb>
                      <el-row class="ButtonTopsection">
                        <el-button type="primary" plain @click="add()">追加</el-button>
                        <el-button type="danger" @click="fn_delete" plain>削除</el-button>
                        <el-button type="info" @click="gototoppage" plain>戻る</el-button>
                      </el-row>
                    </section>
                    <!-- Table section -->
                    <section>
                      <el-table
                      v-loading="loading"
                        border
                        ref="multipleTable"
                        :data="getTableResult1010"
                        style="width: 100%"
                        @selection-change="handleSelectionChange"
                        class="first_table"
                      >
                        <el-table-column
                          fixed
                          type="selection"
                           width="60"
                          class="checkboxFirst"
                        ></el-table-column>
                        <el-table-column label="編集" fixed>
                          <template slot-scope="scope">
                          <el-button size="small" type="primary" @click.native.prevent="edit_rercord(scope.$index, getTableResult1010,scope.row)">編集</el-button>
                          </template>
                        </el-table-column>
                        
                        <el-table-column property="user_group_name" label="ユーザグループID" min-width="200"></el-table-column>
                        <el-table-column property="user_count" label="ユーザ数" min-width="100"></el-table-column>

                        <el-table-column
                          property="use_max_count1"
                          label="ELNET原文利用上限値"
                          min-width="180"
                        ></el-table-column>
                        <el-table-column
                          property="use_max_count2"
                          label="日経原文利用上限値"
                          min-width="180"
                        ></el-table-column>

                        <el-table-column property="demand_id" label="原文利用請求ID" width="200"></el-table-column>
                      </el-table>
                      <el-row class="ButtonBottomsection">
                        <el-button type="primary" plain @click="add()">追加</el-button>
                        <el-button type="danger" @click="fn_delete" plain>削除</el-button>
                        <el-button type="info" @click="gototoppage" plain>戻る</el-button>
                      </el-row>
                    </section>
                  </div>
                </el-container>
              </template>
              <!--SID1010 Body Part End-->
            </pane>
            <pane class="SideBarRight">
              <SideBar class="SidePane" />
            </pane>
          </splitpanes>
        </el-container>
      </div>
      <el-container class="footer-div">
        <el-footer class="footer-element">
          <FooterComponent />
        </el-footer>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Header from "../common/header.vue";
import SideBar from "../common/side-bar.vue";
import FooterComponent from "../common/footerComponent.vue";
import { mapGetters } from "vuex";
import router from "../../router";
import json from "../../components/config.json";
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
const delArr = [];
export default {
  name: "app",
  components: {
    Header,
    SideBar,
    FooterComponent,
    Splitpanes,
    Pane
  },
  data() {
    return {
      form: {},
      dummy: "",
      loading:false,
      TableVisible: false,
      value1: true,
      value2: true,
      value3: true,
      value4: true,
      multipleSelection: [],
       deletetableload:'',
       
    };
  },
  mounted() {
    this.loading=true;
    this.$store.dispatch('communication1010/getTableData1010').then(()=>{
			this.loading=false;
		}).catch(() => {
      this.loading = false;
    })
  },
  computed: {
    ...mapGetters("situation1010", ["getTableResult1010","getDeleteTableData","getresponse","getDeleteMsgDetails"]),
    ...mapGetters("situation0001", [
			"getNews_Article_Flag",
			"getWeb_News_Article_Flag"
		])
  },
  methods: {
    
    add() {
      this.$LogButtonEvent("1010","Add");
			this.$LogMethodIN("1010","add");
      router.push({ name: "1011", params:{Details : ""}});
      this.$LogMethodOut("1010","add");
    },

  edit_rercord(index,rows,row) {
    this.$LogButtonEvent("1010","Edit");
		this.$LogMethodIN("1010","edit_rercord");
    var datasection = 0;
    var news_article_flag = this.getNews_Article_Flag;
    var web_news_article_flag = this.getWeb_News_Article_Flag; 
    
    
    if(news_article_flag == true){
      datasection = 1;
    }

    if(web_news_article_flag == true){
      datasection = 2
    }

    var EditDetails = {
      user_group_id: row.user_group_id,
      data_section : datasection
    };

    this.$store.dispatch('communication1010/EditTableData',EditDetails).then(()=>{
      router.push({
          name: "1011",
          params: {
            response: this.getresponse,
          }
      });
    });
    this.$LogMethodOut("1010","edit_rercord");
  },



    fn_delete() {
      this.$LogButtonEvent("1010","Delete");
      this.$LogMethodIN("1010","fn_delete");
      if (this.$refs.multipleTable.selection.length > 0) {
        this.$confirm(
          json["1010_delete_confirm_message"],
          json["1010_delete_confirm_message_title"],
          {
            showCancelButton: true,
            confirmButtonText: "OK",
            cancelButtonText: "キャンセル"
          }
        ).then(() => {
          var selectedLength = this.$refs.multipleTable.selection.length;
          var DeteleTableArray =[];
          var deletDetails = {};
          for(var i=0;i<selectedLength;i++)
          {
          var user_group_id = delArr['value'][i].user_group_id;
          DeteleTableArray = [...DeteleTableArray,{user_group_id: user_group_id}]
          }
           deletDetails = {
           delete_info:DeteleTableArray
          }  
          
          this.$store.dispatch('communication1010/DeleteTableData1010',deletDetails).then(() => {
                        var status = this.getDeleteTableData
                        if(status == 0){
                            
                            this.$alert( json["1010_delete_success_message"], json["1010_delete_success_title"], {
                                confirmButtonText: 'OK',
                    
                            });
                            
                        }else{
                            this.$alert( this.getDeleteMsgDetails, json["1010_delete_Failure_title"], {
                                confirmButtonText: 'OK',
                    
                            });
                        }  
                    })
                    .catch((error) => { 
                      console.log(error);
                        this.$alert( this.getDeleteMsgDetails, json["1010_delete_Failure_title"], {
                            confirmButtonText: 'OK',
                
                        });
                    });
        });
      } else {
        this.$alert(
          json["1010_checkbox_not_check_message"],
          json["1010_checkbox_not_check_message_title"],
          {
            confirmButtonText: "OK"
          }
        );
      }
      this.$LogMethodOut("1010","fn_delete");
    },
    gototoppage() {
      this.$LogButtonEvent("1010","Return");
      this.$LogMethodIN("1010","gototoppage");
      router.push({ name: "Home" });
      this.$LogMethodOut("1010","gototoppage");
    },
    newFunctionForPOPUP() {
      
      this.$alert(
        json["1010_delete_success_message"],
        json["1010_delete_success_title"],
        {
          confirmButtonText: "OK",
          callback: action => {
            this.$message({
              type: "info",
              message: `action: ${action}`
            });
          }
        }
      );
    },
    handleSelectionChange(val){
       
      delArr.value=  val;
     
    },
  }, 
  beforeCreate(){
		//Common.Session.CheckSessionExists_IfExpired_GoToLogout();
  },
  created(){
     //For the screen Title
     document.title = "ユーザーグループ一覧画面";
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "1010.css";
</style>